import { render, staticRenderFns } from "./immediatePayment.vue?vue&type=template&id=12e722fd"
import script from "./immediatePayment.vue?vue&type=script&lang=js"
export * from "./immediatePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports